<template>

<section class="priorities-grid px-4 py-5%">
    <div class="max-w-4xl mx-auto">
        <SmoothLoader v-if="headline" tag="h2" class="headline text-primary-800 text-4xl vt:text-6xl text-center mb-4 font-headline font-bold leading-tight block">
            {{ headline }}
        </SmoothLoader>
        <SmoothLoader class="grid">
            <Link v-for="post in priorities" :href="post.link" class="block relative bg-expands icon-expands rounded-lg bg-primary-700 p-4 vt:p-8 hover:bg-secondary-600 focus:bg-secondary-600 transition-colors">
                <BackgroundImage v-if="post.thumbnail" :src="post.thumbnail.src" :alt="post.thumbnail.alt" opacity="0.4"></BackgroundImage>
                <div class="relative z-10 h-full flex flex-col">
                    <span class="title font-headline font-bold text-3xl flex-1 block text-white leading-tight pt-12 vt:pt-24" v-html="post.title"></span>
                    <div class="read-more text-white flex items-center justify-end">
                        <span class="font-headline text-xs uppercase font-bold tracking-wider">Read More</span>
                        <i class="fa-solid fa-circle-arrow-right text-xl ml-2" aria-hidden="true"></i>
                    </div>
                </div>
            </Link>
        </SmoothLoader>
    </div>
</section>

</template>

<script>
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>